import * as types from "../constants/actionTypes";
import { postContactUsForm } from "../api/contactUs";
import { generateAsyncAction } from "./generateAsyncAction";

export const sendContactForm = formData => async dispatch => {
  dispatch({ type: types.START_CONTACT_US_REQUEST });
  const sendContactFormAction = await generateAsyncAction({
    onFailAction: sendContactFormFailed,
    onSuccessAction: sendContactFormSuccess,
    asyncApiMethod: postContactUsForm,
    request: formData
  });
  return dispatch(sendContactFormAction);
};

const sendContactFormSuccess = () => dispatch => {
  dispatch({
    type: types.CONTACT_US_REQUEST_HAS_SUCCEED
  });
};

const sendContactFormFailed = () => dispatch => {
  dispatch({
    type: types.CONTACT_US_REQUEST_HAS_FAILED
  });
};



// WEBPACK FOOTER //
// ./src/actions/contactUsActions.js